'use client';

import { useEffect } from 'react';
import { MarketingHeader } from '@/components/marketing/MarketingHeader';
import { useTenant } from '@/app/providers/TenantProvider';

export default function MarketingLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { org } = useTenant();

  useEffect(() => {
    // Apply marketing theme class to body using classList (don't overwrite className)
    document.body.classList.add('theme-marketing');
    
    return () => {
      // Remove marketing theme class on unmount
      document.body.classList.remove('theme-marketing');
    };
  }, []);

  useEffect(() => {
    // Update HTML page title: "Waymaker" or "[tenant name] - Waymaker" in tenant mode
    const pageTitle = org?.name ? `${org.name} - Waymaker` : 'Waymaker';
    document.title = pageTitle;
  }, [org?.name]);

  return (
    <div className="min-h-screen flex flex-col marketing-page-shell">
      <MarketingHeader />
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
}
